var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{staticClass:"filter-search-helper-desktop fullheight"},[_c('CButton',{attrs:{"id":"ribbon","properties":_vm.mapBtn}})],1),_vm._v(" "),_c('div',{staticClass:"filter-search-helper-mobile fullheight"},[_c('CButton',{attrs:{"id":"ribbon","properties":_vm.mapBtnMobile}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }